export default{
    wcOrder:{
        table:{
            tab1:'授信商家',
            tab2:'未出账金额',
            tab3:'剩余额度',
            tab4:'账期类型',
            tab5:'对账日期',
            tab6:'最晚还款期限',
            tab7:'操作',
        },
        msgState:{
            msg1:'账单生成',
            msg2:'每月',
            msg3:'号',
            msg4:'每',
            msg5:'个自然日'
        },
        btnState:{
            btn1:'提前结算',
        },
        
        
    }
    
}